export default __webpack_public_path__ + "img/sg_industry_mixer_2022-cabe792759b8a55f72911638a2d5502d.png";